module.exports = __webpack_public_path__ + "static/img/CC2.da2da0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CC2.png
// module id = 9q04
// module chunks = 0